import { Link, NavLink } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_trusted-trades-57/artifacts/mw9bg41m_logo.png";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/wallet", label: "Worker Wallet", testid: "nav-wallet" },
  { to: "/verify", label: "QR Verify", testid: "nav-verify" },
  { to: "/dashboard", label: "Employer Dashboard", testid: "nav-dashboard" },
  { to: "/admin", label: "Admin", testid: "nav-admin" },
];

export default function Navbar() {
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-2.5">
          <img
            src={LOGO_URL}
            alt="ProCred — Verified Skills. Trusted Workforce."
            className="h-9 w-auto select-none md:h-10"
            draggable={false}
          />
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-[#FF5A1F]"
                    : "text-slate-700 hover:text-[#0B1221]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:hidden">
          <select
            data-testid="nav-mobile-select"
            onChange={(e) => {
              if (e.target.value) window.location.href = e.target.value;
            }}
            className="border border-slate-200 bg-white px-2 py-1 text-sm"
            defaultValue=""
          >
            <option value="" disabled>Menu</option>
            {links.map((l) => (
              <option key={l.to} value={l.to}>{l.label}</option>
            ))}
          </select>
        </div>
      </div>
    </header>
  );
}
